import React, { Fragment, useEffect, useState } from "react";
import {
  Group,
  Card,
  Image,
  Text,
  createStyles,
  Grid,
  Avatar,
  Flex,
  Divider,
  Menu,
  Button,
  Box,
} from "@mantine/core";

import userIcon from "../../assets/img/user.svg";
import sampleUserImg from "../../assets/img/sampleUser.svg";
import femaleImg from "../../assets/img/femaleSample.jpeg";
import stepsLogo from "../../assets/img/Stepsnew.svg";
import heightLogo from "../../assets/img/heightnew.svg";
import BMIlogo from "../../assets/img/bminew.svg";
import weightLogo from "../../assets/img/weightnew.svg";
import bodyTemperatureLogo from "../../assets/img/bodytempnew.svg";
import spo2Logo from "../../assets/img/Spo2new.svg";
import bloodGlucoseLogo from "../../assets/img/Blood Glucosenew.svg";
import bloodPressureLogo from "../../assets/img/Blood Pressuenew.svg";
import bodyfatpercentage from "../../assets/img/body fat.svg"
import heartRateLogo from "../../assets/img/HeartRatenew.svg";
import { useMedplum } from "@medplum/react";
import { useLocation, useParams } from "react-router-dom";
import {
  calculateAge,
  calculateTimeDifference,
  getClientTypes,
  getProfilePicUrl,
} from "../../utils";
import { IconCaretDown } from "@tabler/icons-react";
import timer from "../../assets/img/timernew.svg";

const useStyles = createStyles(() => ({
  userInfoContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "SF Pro Text",
  },
  usericon: {
    width: "18px",
    height: "18px",
  },
  userStaticContainer: {
    border: "1px solid #C9CDD3",
    width: "100%",
    borderRadius: "8px",
  },
  vitalCard: {
    border: "1px solid #C9CDD3",
    borderRadius: "16px",
    width: "100%",
    height: "100%",
    padding: "10px",
  },
  alertvitalCard: {
    border: "1px solid #F12222",
    borderRadius: "16px",
    width: "100%",
    height: "100%",
    padding: "10px",
    backgroundColor: "#FFF0F0",
  },
  platform: {
    border: "1px solid #00B0B938",
    height: "40px",
    padding: "6px 12px 6px 12px",
    borderRadius: "4px",
    boxShadow: "6px",
  },
  platformLogo: {
    marginRight: "10px",
    width: "25px",
    height: "25px",
  },
  center: {
    display: "flex",
    alignItems: "center",
  },
  grid: {
    overflow: "scroll",
    maxHeight: "500px",
    overflowX: "hidden",
    overflowY: "auto",
    scrollbarWidth: "thin",
    scrollbarColor: "#818999 transparent",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#c0c0c0",
      borderRadius: "2px",
    },
  },
}));

const AppointmentCall: React.FC = () => {
  const { classes } = useStyles();
  const medplum = useMedplum();
  const location = useLocation();
  const { patientId }: any = useParams();
  const [patientDetails, setPatientDetails] = useState<any>({});
  const [observations, setObservations] = useState<any>([]);
  const [vitalData, setVitalData] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);

  //Api call in interval
  const [repeater, setRepeater] = useState(1);
  const [wearableDevie, setwearableDevie] = useState({});
  const queryParams = new URLSearchParams(location.search);
  const [selectedClient, setSelectedClient] = useState<any>({
    name: "Google Fit",
  });
  const [clientsOptions, setClientsOptions] = useState<any>([]);
  const callURL = queryParams.get("url");
  const appointmentId = queryParams.get("appointment");
  let apitimeoutId: any;

  useEffect(() => {
    getPatientDetails();

    return () => {
      if (appointmentId) {
        medplum.patchResource("Appointment", appointmentId, [
          { op: "replace", path: "/status", value: "Fulfilled" },
        ]);
      }
    };
  }, []);

  useEffect(() => {
    getDevices();
  }, [patientDetails, selectedClient]);

  useEffect(() => {
    const filteredObjects = observations.reduce((acc: any, curr: any) => {
      const codeText = curr?.code?.text || curr?.valueQuantity?.unit;
      if (codeText && !acc[codeText]) {
        acc[codeText] = curr;
      }
      return acc;
    }, {});

    setVitalData(filteredObjects);
  }, [observations]);

  // Api call in interval
  useEffect(() => {
    getDevices();
    apitimeoutId = setTimeout(() => setRepeater(repeater + 1), 5000);
  }, [repeater]);

  const getPatientDetails = () => {
    medplum
      .searchResources("Patient", `identifier=${patientId}`)
      .then((res: any) => {
        if (res[0]) {
          setPatientDetails(res[0]);
        } else {
          medplum.readResource("Patient", patientId).then((res: any) => {
            
            setPatientDetails(res);
          });
        }
      });
  };

  const getDevices = async () => {
    const devices = await medplum.searchResources(
      "Device",
      `patient=Patient/${patientDetails?.id}`
    );
    const clients = await getClients(devices);

    const googleFitClient = clients?.filter((client) =>
      selectedClient?.id
        ? client?.id === selectedClient?.id
        : client.name === "Google Fit"
    ) as any;
    const device = devices.filter(
      (device) => device?.deviceName?.[0]?.name == googleFitClient[0]?.id
    )[0];
    setwearableDevie(device); //Api call in interval
    if (device) {
      getObservationData(device);
    }
  };

  const getClients = async (devices: any) => {
    const res = await medplum.searchResources(
      "ClientApplication",
      `_count=100`
    );
    const tempNameArr: any = [];
    const tempIdArr: any = [];
    const selectedClientArr: any = [];
    devices.forEach((device: any) => {
      tempNameArr.push(device?.deviceName?.[0]?.name);
      tempIdArr.push(device?.id);
    });
    const newTempArr = [];
    for (let client of res) {
      let tempClient: any = { ...client };
      let clientId = client.id;
      if (tempNameArr.includes(clientId)) {
        let deviceIdx = tempNameArr.indexOf(clientId);
        tempClient["device"] = tempNameArr[deviceIdx];
        tempClient["deviceId"] = tempIdArr[deviceIdx];

        selectedClientArr.push(tempClient);
      }
      const clientTypes = getClientTypes(tempClient?.meta?.extension);
      if (clientTypes?.includes("Wearable")) {
        newTempArr.push(tempClient);
      }
    }

    setClientsOptions(newTempArr);
    return res;
  };

  const getObservationData = async (device: any) => {
    const lonicCodes = [
      "85354-9",
      "2339-0",
      "8867-4",
      "59408-5",
      "8302-2",
      "29463-7",
      "41982-0",
      "41982-0",
      "41950-7",
      "LP416428-3",
      "73985-4",
      "20448-7"
    ];
    let observationBuffer: any = [];

    const promises = lonicCodes.map((code) =>
      medplum
        .searchResources(
          "Observation",
          `code=${code}&patient=${patientDetails?.id}&device=Device/${device?.id}&_sort=-date`
        )
        .then((res) => {
          observationBuffer = [...observationBuffer, ...res];
        })
        .finally(() => {
          setIsLoading(false);
          setObservations(observationBuffer);
        })
    );

    Promise.all(promises).catch((error) => {
      console.error(error);
      clearTimeout(apitimeoutId); //settimeout clear
      setIsLoading(false);
    });
  };

  const vitalLogo = {
    heartrate: heartRateLogo,
    bloodpressure: bloodPressureLogo,
    bloodglucoselevel: bloodGlucoseLogo,
    bodyfatpercentage: bodyfatpercentage,
    spo2: spo2Logo,
    temperature: bodyTemperatureLogo,
    temp: bodyTemperatureLogo,
    steps: stepsLogo,
    height: heightLogo,
    weight: weightLogo,
    oxygensaturationbypulseoximetry: bloodGlucoseLogo,
    hr_max: heartRateLogo,
    bmi: BMIlogo,
    cycling: bloodGlucoseLogo,
    running: bloodGlucoseLogo,
    caloriesburned: bloodGlucoseLogo,
    insulindelivery: bloodGlucoseLogo,
  } as any;

  const UserStatic = () => {
    const statics = {
      City: patientDetails?.address?.[0]?.city.toLowerCase(),
      "Marital Status": patientDetails?.maritalStatus?.coding?.[0]?.display,
      Gender: patientDetails?.gender,
    };
    return (
      <Flex
        className={classes.userStaticContainer}
        justify={"space-around"}
        p={10}
        mb={20}
      >
        {Object.entries(statics)?.map(([key, value]) => (
          <>
            <Flex
              direction={"column"}
              justify={"center"}
              align={"center"}
              key={key}
            >
              <Text weight={500} size={14} color="#818999">
                {key}
              </Text>
              <Text
                weight={600}
                size={16}
                sx={{
                  textTransform: "capitalize",
                }}
              >
                {value}
              </Text>
            </Flex>
            {key !== "Gender" && <Divider orientation="vertical" />}
          </>
        ))}
      </Flex>
    );
  };

  const VitalSigns = () => {
    const vitals =
      (vitalData ? Object.values(vitalData) : [])?.map((vital: any) => {
        const nameWithoutSpaces = (
          vital?.code?.text || vital?.valueQuantity?.unit
        )?.replace(/\s/g, "");

        return {
          image: vitalLogo[nameWithoutSpaces?.toLowerCase()] || "",
          title:
            vital?.code?.text === "Temp"
              ? "Temperature"
              : vital?.code?.text === "hr_max"
              ? "Heart Rate"
              : vital?.valueQuantity?.unit === "steps"
              ? "Steps"
              : vital?.code?.text === "Oxygen Saturation by Pulse Oximetry"
              ? "Oxygen Saturation"
              : vital?.code?.text || "",
          value:
            vital?.code?.text === "Blood Pressure"
              ? vital?.component?.[1]?.valueQuantity?.value : vital?.code?.text === "Cycling" ? vital?.valueQuantity?.value > 1000 ? vital?.valueQuantity?.value/1000: vital?.valueQuantity?.value
              : vital?.valueQuantity?.value || "-",
          unit:
            vital?.code?.text === "Blood Pressure"
              ? vital?.component?.[1]?.valueQuantity?.unit
              : vital?.code?.text === "Cycling" ? vital?.valueQuantity?.value > 1000 ? "km" : vital?.valueQuantity?.unit
              : (vital?.valueQuantity?.unit === "beats/minute"
                  ? "beats/min"
                  : vital?.valueQuantity?.unit) || "",

          effectiveDateTime: vital?.effectiveDateTime || "",
        };
      }) || [];
    const isEffectiveTimeLessThanTenMinutes = (
      effectiveDateTime: string
    ): string => {
      if (effectiveDateTime === "Just now") {
        return "#00a86b";
      } else {
        const effectiveDate = new Date(effectiveDateTime);
        const now = new Date();
        const timeDiffMilliseconds = now.getTime() - effectiveDate.getTime();
        const timeDiffMinutes = Math.abs(timeDiffMilliseconds / (1000 * 60));

        if (timeDiffMinutes < 10) {
          return "#00a86b";
        } else {
          return "#999999";
        }
      }
    };
    

    return (
      <>
        <Flex align={"center"} justify={"space-between"}>
          <Text size={18} weight={600} mr={16}>
            Patient vitals
          </Text>
          <Menu shadow="md">
            <Menu.Target>
              <Button variant="outline" rightIcon={<IconCaretDown />}>
                {selectedClient?.name}
              </Button>
            </Menu.Target>

            <Menu.Dropdown
              pl={0}
              pr={0}
              h={230}
              sx={{
                overflow: "scroll",
              }}
            >
              {clientsOptions.map((client: any) => {
                return (
                  <Fragment key={client.id}>
                    <Menu.Item
                      onClick={(e) => {
                        setSelectedClient(client);
                      }}
                      icon={client.device && <span className="connectDot" />}
                      sx={{
                        backgroundColor: client.device
                          ? "#E7FFE5"
                          : "transparent",
                      }}
                    >
                      {client?.name}
                    </Menu.Item>
                    <Menu.Divider mt={0} mb={0} />
                  </Fragment>
                );
              })}
            </Menu.Dropdown>
          </Menu>
        </Flex>
        <Grid gutter={10} mt={20} className={classes.grid}>
          {vitals.map((vital: any, index: number) => (
            <Grid.Col span={6} key={index}>
              <Group
                className={
                  (vital.title === "Heart Rate" && vital.value > 100) ||
                  (vital.title === "Oxygen Saturation" && vital.value < 85) ||
                  (vital.title === "Spo2" && vital.value < 85) ||
                  (vital.title === "Weight" && vital.value > 150) ||
                  (vital.title === "Body Fat Percentage" && vital.value > 40) ||
                  (vital.title === "Body Temperature" && vital.value > 38) ||
                  (vital.title === "BMI" && vital.value > 30) ||
                  (vital.title === "Blood Pressure" && vital.value > 160) ||
                  (vital.title === "Blood Glucose Level" && vital.value > 180)
                    ? classes.alertvitalCard
                    : classes.vitalCard
                }
              >
                <Flex
                  align={"center"}
                  direction="row"
                  justify={"space-between"}
                >
                  <Image
                    src={vital.image}
                    height={50}
                    width={50}
                    style={{ display: "flex", alignItems: "flex-end" }}
                  />
                  <Flex direction="column">
                    <Text
                      size={12}
                      weight={500}
                      ml={12}
                      color="#99A0AD"
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        maxWidth: "92px", 
                      }}
                    >
                      {vital.title}
                    </Text>
                    <Flex align={"baseline"} justify={"flex-start"} w={"100%"}>
                      <Text
                        size={14}
                        weight={700}
                        ml={12}
                        color={
                          (vital.title === "Heart Rate" && vital.value > 100) ||
                          (vital.title === "Oxygen Saturation" &&
                            vital.value < 85) ||
                          (vital.title === "Spo2" && vital.value < 85) ||
                          (vital.title === "Weight" && vital.value > 150) ||
                          (vital.title === "Body Fat Percentage" &&
                            vital.value > 40) ||
                          (vital.title === "Body Temperature" &&
                            vital.value > 38) ||
                          (vital.title === "BMI" && vital.value > 30) ||
                          (vital.title === "Blood Pressure" &&
                            vital.value > 160) ||
                          (vital.title === "Blood Glucose Level" &&
                            vital.value > 180)
                            ? "Red"
                            : "#262930"
                        }
                      >
                        {vital?.value && vital?.value?.toFixed(1)}
                      </Text>
                      <Text size={8} ml={5} weight={500} color="#474E5B">
                        {vital.unit}
                      </Text>
                    </Flex>
                  </Flex>
                </Flex>

                <Flex justify="flex-end" direction="row" wrap="wrap" w="100%">
                  <Box className={classes.center}>
                    <img src={timer} alt="effective date" />
                  </Box>

                  <Text
                    size={12}
                    ml={8}
                    weight={500}
                    style={{
                      color: isEffectiveTimeLessThanTenMinutes(
                        vital.effectiveDateTime
                      ),
                    }}
                    className={classes.center}
                  >
                    {calculateTimeDifference(vital.effectiveDateTime)}
                  </Text>
                </Flex>
              </Group>
            </Grid.Col>
          ))}
        </Grid>
      </>
    );
  };
    // const profilePicUrl = getProfilePicUrl(patientDetails);

  return (
    <Grid gutter={0}>
      <Grid.Col
        span={4}
        sx={{
          height: "95vh",
          overflow: "scroll",
        }}
      >
        <Card shadow="md" p="lg" radius="md" h={"100%"}>
          <Group spacing="xs" className={classes.userInfoContainer} mb={10}>
            <Flex direction={"column"} justify={"center"} align={"center"}>
              <Avatar
                src={
                  patientDetails?.identifier?.find(
                    (i: any) => i.system === "profile-pic"
                  )?.value ?? null
                }
                size={72}
                mb={16}
                radius={41}
              ></Avatar>

              <Text size={18} weight={600} mb={8}>
                {patientDetails?.name?.[1]?.given?.join(" ")}
              </Text>
              <Flex align={"flex-start"}>
                <img
                  src={userIcon}
                  alt="user-icon"
                  className={classes.usericon}
                />
                <Text size={14} weight={500} color="#586171" ml={8}>
                  {patientDetails?.birthDate &&
                    calculateAge(patientDetails?.birthDate)}
                </Text>
              </Flex>
            </Flex>
          </Group>
          <UserStatic />
          <VitalSigns />
        </Card>
      </Grid.Col>
      <Grid.Col
        span={8}
        sx={{
          height: "95vh",
          overflow: "scroll",
        }}
      >
        {callURL ? (
          <iframe
            width="100%"
            height="100%"
            src={callURL}
            allowFullScreen
            allow="camera *;microphone *; display-capture *; picture-in-picture *; autoplay *; fullscreen *"
            sandbox="allow-scripts allow-downloads allow-same-origin allow-forms"
          />
        ) : null}
      </Grid.Col>
    </Grid>
  );
};

export default AppointmentCall;
